<template>
    <div class="app-container">
        <slot></slot>
    </div>
</template>

<style lang="scss">
.app-container {
    width: 100%;
    padding: 0px 10px;
}
@media (min-width: 600px) {
    .app-container {
        padding: 0px 25px;
    }
}
@media (min-width: 960px) {
    .app-container {
        padding: 0px 30px;
    }
}
@media (min-width: 1280px) {
    .app-container {
        padding: 0px 100px;
    }
}
</style>
